import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import MaterialTable from "material-table";
import { baseURL, headers } from "../../../../../global/api";
import { deleteProduct, updateProduct, getAllProductPDFApi, updateProductStatusApi } from "./Product.action";
import { setHeading } from "../../../accounts/account.actions";
import { changeDateFormate, PDFHeader } from "../../../../../global/globalFunctions";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import jsPDF from "jspdf";
import "jspdf-autotable";
import EditProductModal from "./EditProductModal";
const tableRef = React.createRef();


const ViewProduct = (props) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;

  useEffect(() => {
    props.setHeading("Product Details");
  }, []);

  const handleEditClick = (rowData) => {
    setSelectedRow(rowData);
    setEditModalOpen(true);
  };

  const handleEditSave = (updatedData) => {
    props.updateProduct(updatedData, selectedRow);
    setTimeout(() => {
      tableRef.current && tableRef.current.onQueryChange();
    }, 700);
  };

  const exportPDF = () => {
    props.getAllProductPDFApi();
  };

  return (
    <>
      <EditProductModal
        show={editModalOpen}
        onHide={() => setEditModalOpen(false)}
        rowData={selectedRow}
        onSave={handleEditSave}
      />

      <Container fluid>
        <Button
          style={{ marginBottom: "30px", textTransform: "none", fontSize: "17px" }}
          variant="contained"
          endIcon={<SimCardDownloadIcon />}
          size="large"
          onClick={exportPDF}
        >
          Download Product Report
        </Button>

        <MaterialTable
          tableRef={tableRef}
          title="Product Details"
          columns={[
            { title: "S.No", field: "sequenceNumber" },
            { title: "Category", field: "category.name" },
            { title: "Sub-Category", field: "subCategoryId.subCategoryName" },
            {
              title: "Product Name", field: "name",
              render: (rowData) => (
                <div
                  style={{
                    backgroundColor:
                      rowData.productTypeName === "Variation Product"
                        ? "transparent"
                        : Number(rowData.productBalance) <= Number(rowData.minimumBalance)
                          ? "#ff8d8d"
                          : Number(rowData.productBalance) >= Number(rowData.maximumBalance)
                            ? "#addfac"
                            : "transparent",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content",
                  }}
                >
                  {rowData.name}
                </div>
              ),
            },
            { title: "Closing Balance", field: "productBalance" },
            { title: "Purchase Price", field: "purchasePrice" },
            { title: "Sale Price", field: "salePrice" },
            {
              title: "Status", field: "status",
              render: (rowData) => (
                <div
                  style={{
                    backgroundColor: rowData.status ? "#addfac" : "#ff8d8d",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content",
                  }}
                >
                  {rowData.status ? "Active" : "Blocked"}
                </div>
              ),
            },
            { title: "UOM", field: "uomLabel" },
            { title: "Created At", field: "createdAt", render: (rowData) => changeDateFormate(rowData.createdAt), },
          ]}
          data={(query) =>
            new Promise((resolve) => {
              let url = `${baseURL}/products?allProducts=true`;
              url += "&limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, { method: "GET", headers })
                .then((res) => res.json())
                .then((result) => {
                  resolve({
                    data: result.data,
                    page: result.page,
                    totalCount: result.total_results,
                  });
                });
            })
          }
          detailPanel={(rowData) => (
            <MaterialTable
              columns={[
                { title: "Color", field: "colourLabel" },
                { title: "Size", field: "sizeLabel" },
                { title: "Product Balance", field: "productBalance" },
                { title: "Sale Price", field: "salePrice" },
                { title: "Purchase Price", field: "purchasePrice" },
              ]}
              data={rowData.variation}
              options={{
                actionsColumnIndex: -1,
                toolbar: false,
                exportButton: false,
                sorting: false,
                paging: false,
                pageSize: 50,
                emptyRowsWhenPaging: false,
                headerStyle: { position: "sticky", top: 0, color: "#00BBBB", fontWeight: "550" },
              }}
            />
          )}
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              whiteSpace: "nowrap",
            },
            rowStyle: { whiteSpace: "nowrap" },
            cellStyle: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
            exportPdf: (columns, data) => {
              const doc = new jsPDF("l", "pt", "A4");
              PDFHeader(doc, "Product Details");
              const columnTitles = [
                "Company", "Business Location", "Category", "Sub-Category",
                "Name", "Purchase Price", "Sale Price", "Opening Balance",
                "Closing Balance", "Description", "Status", "Date",
              ];
              const pdfData = data.map((d) => [
                d.retaurantId.restaurantName,
                d.wareHouseId.businessName,
                d.category.name,
                d.subCategoryId.subCategoryName,
                d.name,
                d.purchasePrice,
                d.salePrice,
                d.openingBalance,
                d.productBalance,
                d.desc,
                d.status ? "Active" : "Blocked",
                d.productDate,
              ]);
              doc.autoTable({
                startY: 120, startX: 5,
                head: [columnTitles], body: pdfData,
                headStyles: { fillColor: "#2980ba", font: "Amiri", fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              });
              doc.setProperties({ title: "Product Details" });
              doc.output("dataurlnewwindow");
            },
          }}
          editable={{
            isDeleteHidden: () => Checkpermissions("permissionsSubCatName", "Product Delete"),
            isDeletable: false,
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteProduct(oldData._id);
                }, 600);
              }),
          }}
          actions={[
            {
              icon: "refresh",
              tooltip: "Refresh Data",
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            (rowData) => ({
              disabled: rowData.status !== false,
              icon: () => (
                <TaskAltIcon style={{ color: rowData.status === false ? "green" : "#cccccc" }} />
              ),
              tooltip: "Activate Product",
              onClick: (_e, rowData) => {
                props.updateProductStatusApi(true, rowData._id);
                tableRef.current && tableRef.current.onQueryChange();
              },
            }),
            (rowData) => ({
              disabled: rowData.status !== true,
              icon: () => (
                <BlockIcon style={{ color: rowData.status === true ? "#dc3545" : "#cccccc" }} />
              ),
              tooltip: "Block Product",
              onClick: (_e, rowData) => {
                props.updateProductStatusApi(false, rowData._id);
                tableRef.current && tableRef.current.onQueryChange();
              },
            }),
            (rowData) => ({
              hidden: Checkpermissions("permissionsSubCatName", "Product Edit"),
              icon: () => <EditIcon />,
              tooltip: "Edit Product",
              onClick: (_e, rowData) => handleEditClick(rowData),
            }),
          ]}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  deleteProduct: (id) => dispatch(deleteProduct(id)),
  updateProduct: (payload, oldData) => dispatch(updateProduct(payload, oldData)),
  getAllProductPDFApi: () => dispatch(getAllProductPDFApi()),
  updateProductStatusApi: (status, id) => dispatch(updateProductStatusApi(status, id)),
  setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state) => ({
  productDataList: state.ProductReducer.productDataList,
  isFetchingProduct: state.ProductReducer.isFetchingProduct,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProduct);